import { ForgotPassword } from "@standard/pages/auth";

export default ForgotPassword;
